<template lang="pug">
section
  s-page-title(v-if='isObject(object)' :title='"Планировки БТИ: " + object.object_full_name')
  s-page-title(v-else title='Планировки БТИ: ')
  v-card
    s-data-filter(:initial='search' @search='debouncedSearch')
      template(slot='controls')
        v-layout
          v-flex(xs12)
            v-checkbox(
              v-model='showSold'
              label='Показать проданные'
              hide-details
              color='primary'
              @change='fetchList'
            )

    v-data-table(
      :loading='isLoading'
      :headers='headers'
      :items='list'
      :items-per-page="-1"
      hide-actions
    )
      template(slot='items' slot-scope='props')
        tr()
          td(:class='"status-" + props.item.sold_status') 
            div {{ props.item.apartment_ui }}
            div {{placementStausName(props.item)}}
          td {{ props.item.apart_square }}
          td
            template(v-if="isObject(props.item.bti_plan) && props.item.bti_plan.placement_sizing")
              v-img(
                :aspect-ratio='16/9'
                :lazy-src='props.item.bti_plan.placement_sizing_url'
                :src='props.item.bti_plan.placement_sizing_url'
                class='grey lighten-4'
                contain
              )
                v-layout(
                  slot='placeholder'
                  fill-height
                  align-center
                  justify-center
                  ma-0
                )
                  v-progress-circular(indeterminate color='primary')
            
          td
            template(v-if="isObject(props.item.bti_plan) && props.item.bti_plan.render_view")
              v-img(
                :aspect-ratio='16/9'
                :lazy-src='props.item.bti_plan.render_view_url'
                :src='props.item.bti_plan.render_view_url'
                class='grey lighten-4'
                contain
              )
                v-layout(
                  slot='placeholder'
                  fill-height
                  align-center
                  justify-center
                  ma-0
                )
                  v-progress-circular(indeterminate color='primary')

          td(class='text-xs-right wrapless crud-tools')
            v-btn(icon @click.native="openEditDialog(props.item)")
              v-icon(small) edit
  upload-bti-dialog(
    :btiPlan= 'selectedBtiPlan'
    v-if='uploadDialogIsOpen'
    :isOpen='uploadDialogIsOpen'
    @undo='uploadDialogIsOpen=false'
    @onSave='fetchList'

  )

</template>

<script>
import http from '@/http'
import { debounce } from 'lodash'
import UploadBtiDialog from './UploadBtiDialog'

export default {
  props: ['objectId'],
  components: {
    UploadBtiDialog
  },
  data: () => ({
    uploadDialogIsOpen: false,
    object: null,
    search: '',
    showSold: false,
    selectedBtiPlan: {
      "plan_image_url": null,
      "apartment_ui": null,
      "render_view_url": null,
      "render_view": null,
      "placement_sizing_url": null,
      "placement_sizing": null
    },
    headers: [
      { text: '#ApartmntUI', align: 'left', sortable: false, value: 'apartment_ui', width: '0%' },
      { text: 'Площадь', align: 'left', sortable: false, value: 'apart_square', width: '0%' },
      {
        text: 'Планировка с размерами',
        align: 'left',
        sortable: false,
        width: '25%'
      },
        {
        text: 'Планировка с мебелью',
        align: 'left',
        sortable: false,
        width: '25%'
      },
      { text: '', align: 'left', width: '0%', sortable: false }
    ],
    list: []
  }),

  created() {
    this.fetchList()
    // eslint-disable-next-line no-console
    // console.log(this.list) 
  },

  methods: {

    debouncedSearch: debounce(function(search) {
      this.search = search || ''
      this.fetchList()
    }, 250),

    async fetchList() {
      this.isLoading = true
      try {
        const params = {
          object_id: this.objectId,
          search: this.search
        }
        if (this.showSold) params.showSold = true
        const response  = (await http.get('/complexes/objects/btiplacements/', { params }))
        this.list =  response.data.list
        this.object = response.data.object
      } catch (e) {
        this.$root.showSnack('Не удалось загрузить список')
      }
      this.isLoading = false
    },

    openEditDialog(apartment) {
                  // eslint-disable-next-line no-console
//            console.log(Object.keys(apartment.bti_plan))
      if(apartment.bti_plan)
        Object.keys(this.selectedBtiPlan).forEach(key => {
          if (key in apartment.bti_plan) {
            this.selectedBtiPlan[key] = apartment.bti_plan[key];
          }
          this.selectedBtiPlan['plan_image_url'] = apartment.render_default_url
        });
      else {
        Object.keys(this.selectedBtiPlan).forEach(key => {
            this.selectedBtiPlan[key] = null;
        });
        this.selectedBtiPlan['apartment_ui'] = apartment.apartment_ui
        this.selectedBtiPlan['plan_image_url'] = apartment.render_default_url
      }
        
      this.uploadDialogIsOpen=true
    },

    isObject(value) {
      return typeof value === 'object' && value !== null && !Array.isArray(value);
    },

    placementStausName(item) {
      if(item.sold_status==0) return 'В продаже'
      if(item.sold_status==1) return 'Продано'
      if(item.sold_status==2) return 'Бронь'
      return 'Статус: '+item.sold_status
    }
    // ...mapActions('objects/bti_plans', ['fetchList']),
    // ...mapMutations('objects/bti_plans', ['setDataFilter'])


  },
  
   computed: {

  //   ...mapState('objects/bti_plans', ['total', 'dataFilter']),
  //   ...mapGetters('objects/bti_plans', ['list', 'isLoading'])
   }

}
</script>
<style scoped>

.status-1 {
  color: #afafaf;
}

.status-0 {
  color: #9cb655
}

.status-2 {
  color: #d5b12f
}
</style>